import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import HeaderApp from '../../../../LaridaeApp/components/HeaderApp'
import { getNumericValidator } from '../../../../Forms/fieldValidators'
import CamposPesado0 from '../../../components/pesado/CamposPesado0'

const numeric12 = getNumericValidator(9, 12)

function PesadoDestareChoferLectura (props) {
  const { pesoCabezal, modo, handleSubmit, onBlurInput } = props

  useEffect(() => {
    onBlurInput()
  }, [onBlurInput])

  const label = ''
  const disabled = false
  const validate = [numeric12]

  return (
    <div>
      <div className='App-header-panel'>
        <HeaderApp hideButton />
      </div>
      <div className='contenedor-pesado-chofer'>
        {((modo === 'manual') || (pesoCabezal >= 0))
          ? <>
            <h1>Sr.Transportista por favor verifique su peso de tara</h1>
            <h2>Escanee el código QR en la parte inferior del panel para confirmar su peso de tara</h2>
            { (pesoCabezal >= 0 && modo === 'auto') && <h1
              className='peso-cabezal-chofer'
            >
              {pesoCabezal} <span style={{ fontSize: '2rem' }}>Kg.</span>
            </h1>
            }
          </>

          : <></>
        }
      </div>

      <div className='campos-cea-destare' >
        <form
          onSubmit={handleSubmit}
          style={{ opacity: '0%', position: 'absolute' }}
        >
          <CamposPesado0
            label={label}
            validate={validate}
            disabled={disabled}
            onBlurInput={onBlurInput}
          />
          <Button
            className='btn-pesado-destare'
            type='submit'
            size='lg'
          >
                        Siguiente
          </Button>
        </form>
      </div>
    </div>

  )
}

export default PesadoDestareChoferLectura
